module.exports = __webpack_public_path__ + "img/football_600.f7c06555.png";